import { IDataHandler } from '../IDataHandler';
import { AdTrackingEventName } from '../TrackingEvent';
import { AdDataSet } from '../DataSet/Ad';

export const AdDataMap: {
    [key in AdTrackingEventName]: (keyof AdDataSet)[];
} = {
    [AdTrackingEventName.adRequest]: [
        'adType',
        'placementID',
        'adAdvertisementArea',
        'adGameArea',
        'adRewardType',
        'adID',
        'adLevelNum',
        'adLevelType',
        'adSuccess',
        'adCoinsReceived',
        'adExtraCardsReceived',
    ],
};

export class AdDataHandler implements IDataHandler<AdDataSet> {
    public data: AdDataSet = new AdDataSet();

    public getEventData(eventName: AdTrackingEventName): AdDataSet {
        const data = AdDataMap[eventName].reduce(
            (acc, key) => {
                acc[key] = this.data[key];
                return acc;
            },
            {} as AdDataSet
        );

        this.data = new AdDataSet();

        return data;
    }
}
